export const educationData = [
    {
        id: 1,
        institution: 'Divine English School',
        course: 'Secondary Education',
        startYear: '2017',
        endYear: '2020'
    },
    {
        id: 3,
        institution: 'Gujarat Technological University',
        course: 'Diploma in Computer Engineering',
        startYear: '2020',
        endYear: '2023'
    },
]